import Vue from 'vue'
import Router from 'vue-router'
import Upload from '@/components/Upload'
import UploadShow from '@/components/UploadShow'
import Shows from '@/components/Shows'
import Seasons from '@/components/Seasons'
import Episodes from '@/components/Episodes'
import Watch from '@/components/Watch'
import Unauthenticated from '@/components/Unauthenticated'
import Authenticate from '@/components/Authenticate'
import Playing from '@/components/Playing'
import Dashboard from '@/components/Dashboard';

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/upload',
        name: 'Upload',
        component: Upload
    }, {
        path: '/upload_show',
        name: 'UploadShow',
        component: UploadShow
    }, {
        path: '/shows',
        name: 'Shows',
        component: Shows
    }, {
        path: '/shows/:name',
        name: 'Seasons',
        component: Seasons
    }, {
        path: '/shows/:name/:season',
        name: 'Episodes',
        component: Episodes
    }, {
        path: '/watch/:id',
        name: 'Watch',
        component: Watch
    }, {
        path: '/unauthenticated',
        name: 'Unauthenticated',
        component: Unauthenticated
    }, {
        path: '/authenticate',
        name: 'Authenticate',
        component: Authenticate
    }, {
        path: '/playing',
        name: 'Playing',
        component: Playing
    }, {
        path: '/',
        name: 'Dashboard',
        component: Dashboard
    }],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js